/**
 * Workspace-only supervisor email — the shared MemberSearch (LOGIN-TO-TENANT.md §8.1): server-side search from 2
 * letters, any workspace size. Kept as a thin wrapper so existing imports/props don't change.
 */
import React from 'react';
import MemberSearch from '@stepflow/ui-shared/components/workspace/MemberSearch.jsx';

export default function SupervisorMemberPicker({ value, onChange, tenantId, disabled = false }) {
  return (
    <MemberSearch mode="single" tenantId={tenantId} value={value || ''} onChange={(em) => onChange?.(em)}
      disabled={disabled} ariaLabel="Agent supervisor" testId="supervisor-member-search" />
  );
}
